"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = descToMarkdown;

var _descToJSON = _interopRequireDefault(require("./descToJSON"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var code = '```';

function parseAvailableAt(_ref) {
  var badge = _ref.badge,
      url = _ref.url;
  return "[![](".concat(badge, ")](").concat(url, ")");
}

function getAvailableAt(_ref2) {
  var availableAt = _ref2.availableAt;

  if (!availableAt) {
    return '';
  }

  var availableAtStr;

  if (Array.isArray(availableAt)) {
    availableAtStr = availableAt.map(function (currentAvailable) {
      return parseAvailableAt(currentAvailable);
    }).join(' ');
  } else {
    availableAtStr = parseAvailableAt(availableAt);
  }

  return "\n".concat(availableAtStr);
}

function getHeader(_ref3) {
  var description = _ref3.description,
      details = _ref3.details,
      deprecated = _ref3.deprecated,
      name = _ref3.name;
  return "## ".concat(deprecated ? "~~".concat(name, "~~") : name).concat(deprecated ? " (".concat(deprecated, ")") : '', "\n").concat(description).concat(details ? "\n\n".concat(details) : '', "\n");
}

function getUsage(_ref4) {
  var usage = _ref4.usage;
  return usage ? "\n## Usage\n\n".concat(code, "javascript\n").concat(usage, "\n").concat(code) : '';
}

function getDefaultValue(defaultValue) {
  var defaultValueString = _typeof(defaultValue) === 'object' ? JSON.stringify(defaultValue, undefined, 2) : defaultValue;
  return " Defaults to `".concat(defaultValueString, "`.");
}

function getProperties(_ref5) {
  var _ref5$properties = _ref5.properties,
      properties = _ref5$properties === void 0 ? [] : _ref5$properties;
  var props = properties.map(function (_ref6) {
    var defaultValue = _ref6.defaultValue,
        deprecated = _ref6.deprecated,
        description = _ref6.description,
        format = _ref6.format,
        name = _ref6.name,
        required = _ref6.required;
    return "\n".concat(deprecated ? "**~~".concat(name, "~~**") : "**".concat(name, "**")).concat(deprecated ? " (".concat(deprecated, ")") : '', "\n\n").concat(required ? 'Required. ' : '').concat(description).concat(defaultValue ? getDefaultValue(defaultValue) : '', "\n\n").concat(code, "\n").concat(format, "\n").concat(code);
  });
  return "\n\n## Properties\n".concat(props.join('\n'), "\n  ");
}

function getIntrinsicElement(_ref7) {
  var intrinsicElement = _ref7.intrinsicElement;
  return intrinsicElement ? "\n## Intrinsic element\n\n".concat(code, "\n").concat(intrinsicElement, "\n").concat(code) : '';
}

function descToMarkdown(component, reactDesc) {
  if (!component) {
    throw new Error('react-desc: component is required');
  }

  var documentation = (0, _descToJSON["default"])(component, reactDesc);
  var availableAt = getAvailableAt(documentation);
  var header = getHeader(documentation);
  var usage = getUsage(documentation);
  var properties = getProperties(documentation);
  var intrinsicElement = getIntrinsicElement(documentation);
  return "".concat(header).concat(availableAt).concat(usage).concat(properties).concat(intrinsicElement);
}